import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';
import VacuuGame from './VacuuGame';
import Builds from './Builds';
import './App.css';

const words = [
  'strong', 'brave', 'kind', 'loving', 'smart', 'funny',
  'wonderous', 'inqusitive', 'caring', 'brilliant', 'beautiful', 'handsome',
  'playful', 'curious', 'joyful', 'energetic', 'imaginative', 'adventurous',
  'cheerful', 'silly', 'enthusiastic', 'vibrant',
  'sweet', 'giggly', 'mischievous', 'optimistic', 'gentle',
  'excited', 'creative', 'expressive', 'charming', 'radiant',
  'determined', 'spirited', 'lively', 'happy', 'zany', 'bouncy',
  'beaming', 'sparkling','resilient', 'observant', 'friendly', 'gentle',
  'attentive', 'eager', 'animated', 'sincere'
];

function App() {
  const [currentWord, setCurrentWord] = useState('strong');
  const [bgColor, setBgColor] = useState('#ffffff');
  const [textColor, setTextColor] = useState('#000000');
  const [isRight, setIsRight] = useState(false);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const calculateContrastColor = (bgColor) => {
    // Convert hex to RGB
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);
    
    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black for light backgrounds, white for dark backgrounds
    return luminance > 0.5 ? '#000000' : '#ffffff';
  };

  const getRandomWord = () => {
    const newWord = words[Math.floor(Math.random() * words.length)];
    return newWord === currentWord ? getRandomWord() : newWord;
  };

  const handleSwitch = () => {
    const newBgColor = getRandomColor();
    setCurrentWord(getRandomWord());
    setBgColor(newBgColor);
    setTextColor(calculateContrastColor(newBgColor));
    setIsRight(!isRight);
  };

  return (
    <Routes>
      <Route path="/builds" element={<Builds />} />
      <Route path="/builds/vacuum" element={<VacuuGame />} />
      <Route path="*" element={
        <div className="app" style={{ backgroundColor: bgColor }}>
          <Helmet>
            <title>Lowell Handy</title>
            <meta property="og:title" content="Lowell Handy" />
            <meta property="og:description" content="Lowell Handy" />
          </Helmet>
          <div className="light-switch" onClick={handleSwitch}>
            <div className="switch-base">
              <div className={`switch-toggle ${isRight ? 'right' : 'left'}`}></div>
            </div>
          </div>
          <div className="word" style={{ color: textColor }}>
            {currentWord}
          </div>
        </div>
      } />
    </Routes>
  );
}

export default App;
